module.exports = __webpack_public_path__ + "static/media/26a Body Triangle.211b6042.jpg";